/* Month navigation follows authenticated HTML pages, never a public Content API key. */
(function () {
    var form = document.querySelector('[data-journal-form]');
    if (!form) return;
    var stream = document.querySelector('[data-journal-stream]');
    var status = document.querySelector('[data-journal-status]');
    var pager = document.querySelector('[data-journal-pagination]');
    var button = form.querySelector('button');
    form.addEventListener('submit', async function (event) {
        event.preventDefault();
        var month = form.elements.month.value;
        if (!/^\d{4}-\d{2}$/.test(month)) return;
        button.disabled = true;
        status.textContent = 'Finding entries…';
        var found = [], seen = new Set(), url = form.dataset.latest, pages = 0;
        try {
            while (url) {
                var safe = new URL(url, location.href);
                if (safe.origin !== location.origin || seen.has(safe.href)) throw new Error('Invalid page link');
                seen.add(safe.href);
                var response = await fetch(safe.href, {credentials: 'same-origin', cache: 'no-store'});
                if (!response.ok) throw new Error('Page unavailable');
                var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
                if (!doc.querySelector('[data-journal-stream]')) throw new Error('Please sign in again');
                var entries = Array.from(doc.querySelectorAll('.journal-entry'));
                entries.filter(function (entry) {return entry.dataset.month === month;}).forEach(function (entry) {found.push(entry);});
                pages++;
                status.textContent = 'Checking journal page ' + pages + '…';
                var next = doc.querySelector('[data-journal-pagination] .older-posts');
                var reachedEarlierMonth = entries.some(function (entry) {return entry.dataset.month < month;});
                url = next && !reachedEarlierMonth ? next.getAttribute('href') : null;
            }
            stream.replaceChildren();
            found.forEach(function (entry) {stream.appendChild(document.importNode(entry, true));});
            pager.hidden = true;
            status.textContent = found.length ? found.length + ' entries in ' + month : 'No entries in ' + month + '.';
        } catch (error) {
            status.textContent = 'Could not finish loading this month. Your current entries are unchanged. Check your connection or sign in again, then retry.';
        } finally {
            button.disabled = false;
        }
    });
})();
